"use client";
import { Skeleton } from "@radix-ui/themes";
import { useTranslations } from "next-intl";
import { DataInputParams } from "./inputType";
import { GetDataInputElement, getValueLabel, getValueList } from "./inputFunction";
import { Debug } from "@/util/debug";
import { getSummaryValues } from "../data/list/list";
import { useEffect, useState } from "react";

export default function Summary(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  Debug("Summary : ", params.name, params);
  const [value, setValue] = useState(
    params.name ? getSummaryValues(t, { ...params, field: params.name }, params.codeGroups, params.values, params.locale, true) : undefined,
  );
  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    const temp_function = params.formFunction[params.name];
    if (temp_function) {
      temp_function["setValue"] = (value: any) => {
        setValue(value);
      };
    }
  }

  // const value = params.name
  //   ? getSummaryValues(t, { ...params, field: params.name }, params.codeGroups, params.values, params.locale, true)
  //   : undefined;
  if (value == null || value == undefined) {
    return <Skeleton loading={params.loading ?? false}>{(params.loading ?? false) ? "blank" : " "}</Skeleton>;
  } else {
    //Debug(params);
    // const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
    // const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
    // const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
    // const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
    return (
      <Skeleton loading={params.loading ?? false} className={"field_" + params.name}>
        {value}
      </Skeleton>
    );
  }
}
